import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { INavTab } from '../../interfaces';

@Component({
  selector: 'eq-navigation-tab',
  imports: [
    CommonModule,     
    MatTabsModule,
  ],
  templateUrl: './eqNavigationTab.component.html',
  styleUrl: './eqNavigationTab.component.scss',
  standalone: true
})
export class EqNavigationTabComponent implements OnInit {
  @Input() tabList!: INavTab[];
  @Input() parentRoute!: string; // not required
  @Output() onTabChange = new EventEmitter<INavTab>() 
  activeLink!: string;
  queryParams: any = {};
  
  constructor(
    private router: Router
  ) {}

  ngOnInit(): void {
    this.activeLink = this.router.url;
  }

  navigate(tab: INavTab, params?: any) {
    this.activeLink = tab.link;
    this.router.navigate([tab.link], {
      queryParams: params ? params : this.queryParams,
    });
    this.onTabChange.emit(tab);
  }

}
